import { render, staticRenderFns } from "./EntityMetaDialog.vue?vue&type=template&id=273fe9a4&scoped=true"
import script from "./EntityMetaDialog.vue?vue&type=script&lang=ts"
export * from "./EntityMetaDialog.vue?vue&type=script&lang=ts"
import style0 from "./EntityMetaDialog.vue?vue&type=style&index=0&id=273fe9a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273fe9a4",
  null
  
)

export default component.exports